import { inject, Injectable } from '@angular/core';
import { SEOService } from '@mkp/shared/util-seo';
import { Actions, createEffect, EffectNotification, ofType, OnRunEffects } from '@ngrx/effects';
import { routerNavigatedAction } from '@ngrx/router-store';
import { TranslateService } from '@ngx-translate/core';
import { languageEffectsActions } from '@mkp/core/state/actions';
import { merge, Observable } from 'rxjs';
import { concatMap, startWith, tap } from 'rxjs/operators';

const createLanguageStream = (translateService: TranslateService) =>
  merge(translateService.onFallbackLangChange, translateService.onLangChange);

@Injectable()
export class SeoEffects implements OnRunEffects {
  private readonly actions$ = inject(Actions);
  private readonly seoService = inject(SEOService);
  private readonly languageChanged$ = createLanguageStream(inject(TranslateService));

  readonly updateTitle$ = createEffect(
    () =>
      merge(this.actions$.pipe(ofType(routerNavigatedAction)), this.languageChanged$).pipe(
        tap(() => this.seoService.updateTitle())
      ),
    { dispatch: false }
  );

  readonly updateMetaTags$ = createEffect(
    () =>
      this.languageChanged$.pipe(
        startWith(null),
        tap(() => this.seoService.updateMetaTags())
      ),
    { dispatch: false }
  );

  ngrxOnRunEffects = (
    resolvedEffects$: Observable<EffectNotification>
  ): Observable<EffectNotification> =>
    this.actions$.pipe(
      ofType(
        languageEffectsActions.appLanguageInitializedForUser,
        languageEffectsActions.appLanguageInitializedForVisitor
      ),
      concatMap(() => resolvedEffects$)
    );
}
